import { render, staticRenderFns } from "./goodsTypeModal.vue?vue&type=template&id=62d89121&"
import script from "./goodsTypeModal.vue?vue&type=script&lang=js&"
export * from "./goodsTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports